<template>
    <div class="agent-status-badge" @click="toggleDrawer">
        <span>{{ agentStatus }}</span>
        <i class="icon">ℹ️</i>
    </div>
</template>

<script>
export default {
  name: 'AgentStatusBadge',
  data() {
    return {
      agentInfo: null,
      agentEventSource: null,
    };
  },
  computed: {
    agentStatus() {
      return this.agentInfo?.active ? 'Agent: active' : 'Agent: inactive';
    }
  },
  mounted() {
    this.subscribeToSSE();
  },
  beforeDestroy() {
    this.unsubscribeFromSSE();
  },
  methods: {
    subscribeToSSE() {
      this.agentEventSource = new EventSource(`/api/active_auction/?action=agent:status`, {
        withCredentials: true
      });
      this.agentEventSource.onopen = () => {
        // console.debug('SSE connection opened');
      };
      this.agentEventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          this.agentInfo = data.data;
          this.$root.$emit('agent-info-updated', this.agentInfo);
        } catch (error) {
          console.error('Error parsing JSON: ', error);
        }
      };
      this.agentEventSource.onerror = (error) => {
        console.error('SSE error: ', error);
      };
      window.addEventListener('beforeunload', this.unsubscribeFromSSE);
    },
    toggleDrawer() {
      this.$root.$emit('toggle-drawer');
    },
    unsubscribeFromSSE() {
      if (this.agentEventSource) {
        this.agentEventSource.close();
      }
      window.removeEventListener('beforeunload', this.unsubscribeFromSSE);
    },
  }
};
</script>

<style scoped>
.agent-status-badge {
  cursor: pointer;
  position: absolute;
  width: auto;
  bottom: 5px;
  right: 0;
  background-color: #f0f0f0;
  padding: 5px 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.agent-status-badge .icon {
  margin-left: 10px;
}
</style>